import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from '../coches/vehicleSpecifications/categories.js'
import {
  ALL_VEHICLES_LISTING_SECTION_ID,
  AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
  NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
  VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID
} from '../common/listingSections.js'

export const LISTING_SECTION_IDS_BY_CATEGORIES = {
  [CARS_CATEGORY1_ID]: ALL_VEHICLES_LISTING_SECTION_ID,
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
  [CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID
}

export const ARE_STOCK_FILTERS_AVAILABLE = true
